import React from 'react'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import { defaultPalette } from '../../../theme/idsTheme'
import Callout from '../../Common/callout/Callout'

const ContactCallout: React.FC = () => (
    <Callout color={defaultPalette.primary.main} icon={<InfoRoundedIcon />}>
        Un correspondant est un professionnel de santé qui reçoit les documents de santé associés à chaque acte effectué
        pour le patient qu'il suit, à condition que ce dernier possède un courriel sécurisé de santé (information
        récupérée automatiquement depuis l’annuaire santé).
    </Callout>
)

export default ContactCallout
